import MUIContainer from '@/components/MUI-Components/MUI-Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import {contentMaxWidth, colors, fontSize, spacing, zIndex} from '@/styles/tokens';

const wrapperSx = {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: '60vh',
    paddingTop: '30px',
    paddingBottom: '30px',
    position: 'relative',
    background: `radial-gradient(circle at 30% 50%, rgba(222, 235, 247, 0.9), transparent 50%),
        radial-gradient(circle at 70% 50%, rgba(255, 230, 224, 0.9), transparent 50%)`,
    backgroundColor: colors.text.inverse,
    overflow: 'hidden',
    '@media (min-width: 600px)': {minHeight: '80vh'},
    '@media (min-width: 900px)': {minHeight: 'calc(70vh - 130px)'}
} as const;

const innerSx = {position: 'relative', zIndex: zIndex.raised} as const;

const contentSx = {maxWidth: contentMaxWidth.standard, marginLeft: 'auto', marginRight: 'auto', textAlign: 'center'} as const;

const headingSx = {
    fontSize: '35px !important',
    fontWeight: '700 !important',
    color: `${colors.text.primary} !important`,
    marginBottom: '0.35em !important',
    lineHeight: '1.2 !important',
    '@media (min-width: 600px)': {fontSize: `${fontSize[65]} !important`},
    '@media (min-width: 600px) and (max-width: 950px)': {fontSize: `${fontSize[48]} !important`}
} as const;

const subheadingSx = {
    fontSize: `${fontSize[18]} !important`,
    color: `${colors.text.primary} !important`,
    marginBottom: `${spacing[32]} !important`,
    lineHeight: '1.75 !important'
} as const;

const LatestPortfolioBanner = (props: any) => {
    const {heading, subheading, headingLevel = 'h1'} = props;
    return (
        <Box sx={wrapperSx}>
            <MUIContainer sx={innerSx}>
                <Box sx={contentSx}>
                    <Typography variant="h1" component={headingLevel} sx={headingSx}>
                        {heading}
                    </Typography>

                    <Typography variant="subtitle1" component="p" sx={subheadingSx}>
                        {subheading}
                    </Typography>
                </Box>
            </MUIContainer>
        </Box>
    );
};

export default LatestPortfolioBanner;
